import { jsx } from "react/jsx-runtime";
import RotateRightIcon from "@mui/icons-material/RotateRight";
import { validateTidalLicense } from "../../base/index.js";
function RotateRight(props) {
  return /* @__PURE__ */ jsx(
    RotateRightIcon,
    {
      "data-testid": "RotateRight",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "RotateRight",
      "data-tidal-icon-meta": "arrows"
    }
  );
}
RotateRight.tidalIconMeta = {
  categories: "arrows",
  name: "RotateRight"
};
validateTidalLicense();
export {
  RotateRight
};
//# sourceMappingURL=RotateRight.js.map
